import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

export default function FilterDialog({ open, handleClose, optionsCategories, category, cursoId, setNewCat, setCursoId }) {
  const [trails, setTrails] = useState([])
  const [trailsStep, setTrailsStep] = useState([])
  const [categoriaId, setCategoriaId] = useState(null)
  const [filter, setFilter] = useState({ curso_id: '', categoria_id: '', subcategoria_id: '' })

  

  const currentCourse = optionsCategories && optionsCategories.find(row => row._id === cursoId)

  const currentCategory = ((currentCourse || []).trilhas || []).find(item => item.items.find(row => row._id === category))

  const currentSubcategory = ((currentCategory || {}).items || []).find(item => item._id === category)

  const getCategorieId = subcat => {
    setFilter({ ...filter, subcategoria_id: subcat })
    setCategoriaId(subcat)
  }

  useEffect(() => {
    setTrails((currentCourse || []).trilhas)
    setTrailsStep(currentCategory)
    setCategoriaId((currentSubcategory || {})._id)
    setFilter({
      curso_id: (currentCourse || {})._id,
      categoria_id: (currentCategory || {}).titulo,
      subcategoria_id: (currentSubcategory || {})._id
    })
  }, [currentCourse, currentCategory, currentSubcategory])

  const filterTrailsByCourse = course => {
    setCursoId(course)
    setFilter({ ...filter, curso_id: course })

    var trailsToList = optionsCategories.find(row => row._id === course)

    var obj = {}

    const trilhas = (trailsToList || []).trilhas

    if (trilhas) {
      for (var i = 0, len = trilhas.length; i < len; i++) {
        obj[trilhas[i].titulo] = trilhas[i]
      }
    }

    trailsToList = []

    for (var key in obj) {
      trailsToList.push(obj[key])
    }

    setTrails(trailsToList)
  }

  const filterTrailsStepByTrailTitle = categoria => {
    if (categoria === 'all') {
      setCategoriaId('all')
      setTrailsStep([])
      setFilter({ ...filter, categoria_id: 'all', subcategoria_id: '' })
    } else if (categoria === 'Geral') {
      setCategoriaId(null)
      setTrailsStep([])
      setFilter({ ...filter, categoria_id: 'Geral', subcategoria_id: '' })
    } else {
      setFilter({ ...filter, categoria_id: categoria })
    }

    const trailsStepToList = (trails || []).find(row => row.titulo === categoria)
    setTrailsStep(trailsStepToList)
  }

  const handleFilter = () => {
    setNewCat(categoriaId === undefined ? 'all' : categoriaId)
    handleClose()
  }

  return (
    <div>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{'Categorias'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <form id={'form_form'}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-helper-label">Módulo</InputLabel>
                <Select label="Módulo" value={filter.curso_id} onChange={e => filterTrailsByCourse(e.target.value)}>
                  {(optionsCategories || []).map(item => {
                    return (
                      <MenuItem key={item._id} value={item._id || item.titulo}>
                        {item.titulo}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <FormControl disabled={(trails || {}).length === 0 ? true : false} variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-helper-label">Categoria</InputLabel>
                <Select label="Categoria" value={filter.categoria_id} onChange={e => filterTrailsStepByTrailTitle(e.target.value)}>
                  <MenuItem value="all">Todas as categorias</MenuItem>
                  <MenuItem key={null} value={'Geral'}>
                    Geral
                  </MenuItem>
                  {(trails || []).map(trilha => {
                    return (
                      <MenuItem key={trilha.titulo} value={trilha.titulo}>
                        {trilha.titulo}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <FormControl disabled={((trailsStep || []).items || []).length === 0 ? true : false} variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-helper-label">Subcategoria</InputLabel>
                <Select label="Subcategoria" value={filter.subcategoria_id} onChange={e => getCategorieId(e.target.value)}>
                  {((trailsStep || []).items || []).map(step => {
                    return (
                      <MenuItem key={step._id} value={step._id}>
                        {step.titulo}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button style={{ marginRight: '12px' }} onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleFilter} style={{ width: 130 }} color="primary" variant="contained" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
